import React, { useEffect, useState } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect } from "react-router";
import { getSelectedProperty } from "./PropertyDetails";
import Strings from "@my-dld/assets/strings";
import { DashboardBCItem, TabuPropertyBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { exToMessage, getAllImages } from "@10x/dubai-rest-api/dist/property_images/api";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import {
	canAddImages,
	getDefaultPosition,
	getPropertyImageUrl,
	ImageView,
	RenderUploadImages
} from "@my-dld/components/PropertyDetails/PropertyPhotos";
import { PropertyImage } from "@10x/dubai-rest-api/dist/property_images/entity";
import PropertyPhotosModal, { downloadPropertyPhotos, shrePropertyPhotos } from "@my-dld/components/PropertyDetails/PropertyPhotosModal";

interface Props extends RoutedViewProps<{ propertyTypeId: string; propertyId: string }> {

}

interface State {
	property?: AssetCard;
	images: PropertyImage[];
	position: number;
	defPosition: number;
	showModal: boolean;
	isSelMode: boolean;
	selIndexes: number[];
	canAdd: boolean,
}

function PropertyAllPhotos( props: Props ) {
	const [ state, setState ] = useState<State>( {
		property: getSelectedProperty( props.match.params ),
		images: [],
		position: 0,
		defPosition: 0,
		showModal: false,
		selIndexes: [],
		isSelMode: false,
		canAdd: true,
	} );

	useEffect( () => {
		if ( state.property ) {
			showLoading();
			const { propertyId, isFreeHold } = state.property;
			getAllImages( "" + propertyId, isFreeHold ).then( r => {
				hideLoading();
				const nImages = r.data;
				setState( prevState => ( {
					...prevState,
					images: nImages,
					defPosition: getDefaultPosition( nImages ),
					canAdd: canAddImages( nImages ),
				} ) );
			} ).catch( e => {
				hideLoading();
				if ( e.code !== 404 ) {
					exToMessage( e ).then( message => {
						showMessage( message.error );
					} );
				}
			} );
		}
	}, [] );

	const onSelect = () => {
		setState( prevState => ( {
			...prevState,
			isSelMode: !state.isSelMode,
			selIndexes: [],
		} ) );
	};

	const onImageClick = ( index: number ) => {
		let { isSelMode, selIndexes } = state;
		if ( isSelMode ) {
			if ( selIndexes.includes( index ) ) {
				selIndexes = selIndexes.filter( i => i !== index );
			} else {
				selIndexes.push( index );
			}
			setState( prevState => ( {
				...prevState,
				selIndexes: selIndexes,
			} ) );
		} else {
			showModal( true, index );
		}
	};

	const showModal = ( show: boolean, index: number ) => {
		setState( prevState => ( {
			...prevState,
			showModal: show,
			position: index,
		} ) );
	};

	const onUploadComplete = ( images: PropertyImage[] ) => {
		setState( prevState => ( {
			...prevState,
			isSelMode: false,
			selIndexes: [],
			images: images,
			defPosition: getDefaultPosition( images ),
			canAdd: canAddImages( images ),
		} ) );
	};

	const onDelete = ( images: PropertyImage[] ) => {
		setState( prevState => ( {
			...prevState,
			images: images,
			defPosition: getDefaultPosition( images ),
			canAdd: canAddImages( images ),
		} ) );
	};

	const onPrimary = ( images: PropertyImage[] ) => {
		setState( prevState => ( {
			...prevState,
			images: images,
			defPosition: getDefaultPosition( images ),
			showModal: false,
		} ) );
	};

	const onShare = () => {
		showLoading();
		const images: PropertyImage[] = [];
		state.selIndexes.forEach( ( selIndex: number ) => {
			images.push( state.images[ selIndex ] );
		} );
		shrePropertyPhotos( images, () => {
			hideLoading();
		}, state.property );
	};

	const onDownload = () => {
		showLoading();
		const images: PropertyImage[] = [];
		state.selIndexes.forEach( ( selIndex: number ) => {
			images.push( state.images[ selIndex ] );
		} );
		downloadPropertyPhotos( images, () => {
			hideLoading();
		}, state.property );
	};

	if ( state.property == null )
		return <Redirect to={ "/mydld" }/>;
	const { propertyTypeId, propertyId } = state.property;
	return <div className="container">
		<PageTitle
			title={ Strings.property_photos }
			paths={ [ DashboardBCItem, TabuPropertyBCItem( "" + propertyTypeId, "" + propertyId ) ] }/>
		<div className="row">
			<div className="col-md-12 property-images">
				<div className="content-section">
					<div className="content-section-title">
                        <span className="section-title-span">
                            { `${ Strings.property_photos } (${ state.images.length })` }</span>
						<RenderUploadImages
							canAdd={ state.canAdd } size={ state.images.length }
							property={ state.property } onUploadComplete={ onUploadComplete }/>
					</div>
				</div>
				<div className="p-image-control">
					{ state.selIndexes.length > 0 && <span className="selected-img-count font-size14">
                        { `${ state.selIndexes.length } ${ Strings.selected }` }</span> }
					<div>
						{ state.selIndexes.length > 0 && <button
							type="button" className="btn btn-link btn-sm"
							onClick={ onDownload }>{ Strings.download }</button> }
						{/*{ state.selIndexes.length > 0 && isShareSupport() &&
                        <button type="button" className="btn btn-link btn-sm"
                                onClick={ onShare }>{ Strings.share }</button> }*/ }
						<button
							type="button" className="btn btn-link btn-sm select-image"
							onClick={ onSelect }>{ state.isSelMode ? Strings.cancel : Strings.select }</button>
					</div>
				</div>
				<div className="card mb-3">
					<div className="card-body">
						<div className="form-row">
							{ state.images.map( ( image: PropertyImage, index: number ) => {
								const isDefault = ( state.defPosition === index );
								const imageUrl = getPropertyImageUrl( image, state.property );
								const isSelected = state.selIndexes.includes( index );
								return <div
									key={ `${ index }-${ image.id }` }
									className={ `col-md-2 ${ isDefault ? "property-main-img" : "" }` }
									onClick={ () => onImageClick( index ) }>
									{ state.isSelMode && <div className="select-img-checkbox">
										<input
											type="checkbox" checked={ isSelected }
											onChange={ () => false }/>
										<label/>
									</div> }
									<ImageView imageUrl={ imageUrl }/>
									{/*{ isDefault && <span>{ Strings.main }</span> }*/ }
								</div>;
							} ) }
						</div>
					</div>
				</div>
			</div>
		</div>
		{ state.showModal && <PropertyPhotosModal
			property={ state.property }
			images={ state.images }
			defPosition={ state.defPosition }
			position={ state.position }
			onDismiss={ () => showModal( false, 0 ) }
			onDelete={ onDelete }
			onPrimary={ onPrimary }/> }
	</div>;
}

export default PropertyAllPhotos;
